
<mat-calendar [selected]="date()" (selectedChange)="date.set($event)"/>

<mat-dialog-actions>
    <button mat-button matDialogClose>CANCEL</button>
    <button mat-button color="primary" [disabled]="!date()" (click)="select()">OK</button>
</mat-dialog-actions>
